import React from "react";
import Grid from "@material-ui/core/Grid";
import MyPagination from "../../Components/MyPagination";
import Tweet from "../../Components/Tweet";
import Layout from "../../Layout";
import PosiTabs from "../../Components/PosiTabs";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Avatar from "@material-ui/core/Avatar";
import { Typography } from "@material-ui/core";
import queryString from "query-string";
import OrderSelect from "Components/OrderSelect";
import { animateScroll as scroll } from 'react-scroll';

import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import useFilter from "Hooks/useFilter";
import googleAnalytics from "fuction/googleAnalytics";
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import Toolbar from '@material-ui/core/Toolbar';
import { useQueryString, modQueryPageNum, getQueryPageNum } from "Hooks/useQueryString";

import dayjs from "dayjs";
dayjs.locale("ja");

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(3),
    minWidth: 120,
  },
  sticky: {
    position: "-webkit-sticky", /* safari対応 */
    position: "sticky",
    top: 64,
    zIndex: 1,
    backgroundColor: "white",
    paddingLeft: 90,
    paddingRight: 90,
    width: "100%",
  },
}));

export default function UserDetail(props) {
  const { request, convertQueryParam } = useApi();
  const filter = useFilter();
  const auth = useAuth();
  const classes = useStyles();
  const queryParams = useQueryString();

  const [tweets, setTweets] = React.useState([]);
  const [meta, setMeta] = React.useState({});
  const [user, setUser] = React.useState({});
  const [totalCount, setTotalCount] = React.useState(0);
  const [page, setPage] = React.useState(getQueryPageNum(queryParams));
  const [order, setOrder] = React.useState("desc");
  const [isHideImage, setIsHideImage] = React.useState(false);

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 投稿者分析";
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  // ツイート情報を取得
  const rquestTweets = () => {
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }

    let fromDate = "";
    let toDate = "";

    if (queryString.parse(props.location.search).dateTo &&
      queryString.parse(props.location.search).dateTo != "" &&
      queryString.parse(props.location.search).dateFrom &&
      queryString.parse(props.location.search).dateFrom != "") {
        fromDate = queryString.parse(props.location.search).dateFrom;
        toDate = queryString.parse(props.location.search).dateTo;
    } else {
      fromDate = dayjs(filter.state.filteredDateFrom).format(
        "YYYY-MM-DD 00:00:00"
      );
      toDate = dayjs(filter.state.filteredDateTo).format(
        "YYYY-MM-DD 23:59:59"
      );
    }

    const { user } = queryString.parse(props.location.search);
    const screenName = user;

    Promise.all([
      request({
        method: "GET",
        url: `data/:account_id/users/${
          auth.state.activeGroup
        }/statuses?${convertQueryParam({
          user: screenName,
          range: [fromDate, toDate],
          filter: {
            pn: filter.state.posiNegaTab,
          },
          order: order,
          pagination: {
            page: page,
            limit: "50",
          },
        })}`,
      }),
    ]).then(([tweets]) => {
      // user はこの取り方をしないと画像が取得できないほうの profile_image_url_https になってしまうことがある（ほんとは setUser(tweetw.data[0].user) でいいはずなんだけど、なぜか profile_image_url_https の値が複数種類あり、初回アクセス時はなぜか画像取得可能 URL がくる）
      const info = profileImage ? tweets.data.find((info) => info.user.profile_image_url_https === profileImage) : tweets.data.find((info) => info.user.screen_name === screenName);
      setUser((pr) => info?.user ? info.user : pr);
      setMeta(tweets.meta);
      setTweets(tweets.data);
      setTotalCount(tweets.meta.total_count);
      scrollToTop()
    });
  }

  // 初回レンダリングフラグ
  const isFirstRender = React.useRef(false);
  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 投稿者分析";
    isFirstRender.current = true;
  }, []);

  React.useEffect(() => {
    // 初回レンダー判定
    if(isFirstRender.current) {
      // 初回レンダーではないように
      isFirstRender.current = false;
    } else {
      rquestTweets();
    }
  }, [page]);

  const syncQueryPageNum = (...[pn]) => {
    if ((pn && pn === 1) || (totalCount > 0 && (Math.ceil(totalCount / 50)) < getQueryPageNum(queryParams))) {
      modQueryPageNum(queryParams, 1);
      props.history.push(props.location.pathname + "?" + queryParams.toString());
      setPage(1);
    }
    else {
      setPage(getQueryPageNum(queryParams));
    }
  }

  React.useEffect(() => {
    if (auth.state.activeGroup === 0) {
      return;
    }
    if (page === 1) {
      rquestTweets();
    } else {
      syncQueryPageNum(1);
    }
  }, [auth.state.activeGroup, order, filter.state]);

  // profile_image_url_https はほんとに user が変わったときだけ更新されるようにメモ化して持っとく
  const profileImage = React.useMemo(() => user.profile_image_url_https, [user]);

  if (page !== getQueryPageNum(queryParams)) {
    syncQueryPageNum();
  }
  return (
    <Layout
      content={
        <Grid container spacing={3}>
          <Toolbar className={classes.sticky}>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-start"
              >
                <PosiTabs />
                <div className={classes.divider}></div>
                <OrderSelect
                  handleChangeOrderSelect={(value) => {
                    setPage(1);
                    setOrder(value);
                  }}
                  value={order}
                />
                <div className={classes.divider}></div>
                <FormControl component="fieldset" className={classes.formControl}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Switch size="small" checked={isHideImage} onChange={(event) => setIsHideImage(event.target.checked)} name="isHideImage" />}
                      label="画像を表示しない"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid container spacing={3} className={classes.formControl} justifyContent="center">
                <MyPagination
                count={Math.ceil(totalCount / 50)}
                currentPage={page}
                handlePagination={(page) => setPage(page)}
                />
              </Grid>
            </Grid>
          </Toolbar>
          <Grid item>
            <Typography>{totalCount}件</Typography>
          </Grid>
          <Grid container>
            <Grid>
              <Avatar alt={meta.user_name} src={profileImage} />
              </Grid>
            <Grid>
              <Typography>
                {meta.user_name}（
                <a
                  href={`https://twitter.com/${meta.screen_name}`}
                  target="_blank"
                >
                  ＠{meta.screen_name}
                </a>
                )
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {tweets.map((row, index) => (
              <Tweet
                row={row}
                isPrimaryHide={true}
                key={index}
                isHideImage={isHideImage}
              />
            ))}
          </Grid>
        </Grid>
      }
    />
  );
}
